// src/features/staff/pages/StaffDetailsPage/components/StaffTabSection.jsx
import React from 'react';
import { Box, Card, CardContent, CircularProgress, Typography } from '@mui/material';

/**
 * The frame every staff tab sits in, so the tabs look alike: a card with an
 * icon, title and optional subtitle on the left and the tab's actions on the
 * right. With `fill` the card stretches to the panel's full height (the panel
 * needs `fill` too). With `loading` the body shows a spinner.
 */
export default function StaffTabSection({ icon: Icon, title, subtitle, actions, loading = false, fill = false, children }) {
  const fillSx = fill ? { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' } : {};
  return (
    <Card sx={fillSx}>
      <CardContent sx={fillSx}>
        <Box display="flex" alignItems="center" justifyContent="space-between" gap={2} mb={3}>
          <Box display="flex" alignItems="center" gap={2} minWidth={0}>
            {Icon && <Icon color="primary" />}
            <Box minWidth={0}>
              <Typography variant="h6">{title}</Typography>
              {subtitle && (
                <Typography variant="body2" color="text.secondary" component="div">
                  {subtitle}
                </Typography>
              )}
            </Box>
          </Box>
          {actions && <Box display="flex" alignItems="center" gap={2} flexShrink={0}>{actions}</Box>}
        </Box>

        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : children}
      </CardContent>
    </Card>
  );
}
